
import { Component, Vue, Prop } from 'vue-property-decorator'
import { commonModule, jobsModule, partnersModule } from '@/store/modules/store-accessor'

@Component
export default class CompleteJobConfirmModal extends Vue {
  @Prop()
  payload!: Record<string, JobDto>;

  isCompleting = false;

  async hideModal () {
    commonModule.hideModal();
  }

  async mounted() {
    commonModule.initSnackbar({});
  }

  async doCompleteJob () {
        this.isCompleting = true;

        const job = {
            is_complete: true,
            id: this.payload.job.id,
            installation_id: this.payload.job.installation_id,
            partner_id: partnersModule?.currentPartner?.info?.partner_id,
        };

        try {
            await jobsModule.updateJobComplete({ ...job });
        } finally {
            this.isCompleting = false;
            this.hideModal();
        }
  }
};
